import { useEffect, useState } from 'react';
import http from '../../utils/http-common';
import LogoLoaderGif from '../../assets/images/logo.gif';

const GlobalLoader = () => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const reqInterceptor = http.interceptors.request.use(
      function (config) {
        setLoading(true);
        return config;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );
    const resInterceptor = http.interceptors.response.use(
      function (response) {
        setLoading(false);
        return response;
      },
      function (error) {
        setLoading(false);
        return Promise.reject(error);
      }
    );
    return () => {
      http.interceptors.request.eject(reqInterceptor);
      http.interceptors.response.eject(resInterceptor);
    };
  }, []);
  return (
    <div>
      {loading && (
        // <div className="fixed w-full h-full left-0 top-0 z-[50] bg-[rgba(255,255,255,.7)] justify-center items-center flex">
        //   <img src={LogoLoaderGif} className="max-w-[200px]" alt="" />
        // </div>
        <div className="fixed w-full h-full left-0 top-0 z-[50] bg-[rgba(255,255,255,.7)] justify-center items-center flex">
          <div className="flex items-center justify-center py-16">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalLoader;
